<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>C端数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>意见反馈管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="80px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否处理" prop="isHandle">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.isHandle"
              >
                <el-option label="已处理" :value="1"></el-option>
                <el-option label="未处理" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">意见反馈列表</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="问题类型" prop="feedbackTypeStr"></el-table-column>
        <el-table-column label="问题描述" prop="feedbackContent" width="200px">
          <template slot-scope="scope">
            <div class="textarea">{{ scope.row.feedbackContent }}</div>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="学校" prop="schoolName" width="120px"></el-table-column>
        <el-table-column label="年级" prop="gradeStr"></el-table-column>
        <el-table-column label="微信号" prop="weChat"></el-table-column>
        <el-table-column label="问题图片" width="200px" prop="feedbackUrl">
          <template slot-scope="scope">
            <el-image class="img"
              v-for="(url,index) of scope.row.feedbackUrl" :key="index"
              :src="url"
              fit="contain"
              :preview-src-list="scope.row.feedbackUrl">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" prop="createTime"></el-table-column>
        <el-table-column label="是否处理" prop="isHandle" width="120px">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isHandleBoolean"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeStatus(scope.row)"
              >
            </el-switch>
            {{ scope.row.isHandle ? '已处理' : '未处理' }}
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  data () {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        userName: '',
        phone: '',
        isHandle: ''
      },
      dataList: [],
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getList () {
      this.$http.get('feedBack/querySysFeedBackPage', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          res.data.list.forEach(item => {
            item.feedbackUrl = item.feedbackUrl ? JSON.parse(item.feedbackUrl) : []
            item.isHandleBoolean = item.isHandle === 1
          })
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    search () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    reset () {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        userName: '',
        phone: '',
        isHandle: ''
      }
      this.getList()
    },
    changeStatus (item) {
      console.log(item)
      this.$http.post('feedBack/updateSysFeedBack', { id: item.id, isHandle: item.isHandleBoolean ? 1 : 0 }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.getList()
        }
      })
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getList()
    }
  }
}
</script>
<style scoped lang="less">
.textarea{
  white-space: pre-wrap;
  word-wrap: break-word;
}
.img{
  width: 40px;
  height: 40px;
  margin-right: 10px;

}
</style>
